module.exports = __webpack_public_path__ + "img/banner-01.4911d79d.png";